import type BaseHttpService from "../../client/BaseHttpService";
import type { ApiResponse } from "../../client/types";

export type ShortUrlResponse = { short_url: string };

export class UrlShortenerApi {
	private static readonly BASE_PATH = "/api/v1";

	constructor(private readonly http: BaseHttpService) {}

	async createShortUrl(url: string): Promise<ShortUrlResponse> {
		const response = await this.http.post<ApiResponse<ShortUrlResponse>>(
			"Creating short URL",
			`${UrlShortenerApi.BASE_PATH}/create-short-link`,
			{ url },
		);
		return response.data;
	}
}
